import reducerRegistry from '@comeon/reducer-registry';
import type { CasinoSharedAction } from '../../ducks/types';
import {
	CLEAN_UP,
	REDUCER_NAME,
	SET_CLEANUP_LISTENERS,
	SET_CURRENT_GAME,
	SET_GAME_LOADER_REQUEST_PENDING,
	SET_GAME_LOADER_RESPONSE,
	SET_GAME_MODE,
	SET_LOAD_AS
} from './constants';
import type { State } from './types';

export const initialState: State = {
	currentGame: null,
	gameLoaderResponse: null,
	gameLoaderRequestPending: false,
	status: '',
	hydrated: false,
	loadAs: '',
	gameMode: '',
	errorCode: '',
	errorDescription: '',
	cleanUpListeners: null
};

const reducer = (state = initialState, action: CasinoSharedAction) => {
	switch (action.type) {
		case CLEAN_UP: {
			return initialState;
		}
		case SET_CLEANUP_LISTENERS: {
			return {
				...state,
				cleanUpListeners: action.payload
			};
		}
		case SET_CURRENT_GAME: {
			return {
				...state,
				currentGame: action.payload,
				hydrated: false,
				status: '',
				errorCode: '',
				gameLoaderResponse: null
			};
		}
		case SET_GAME_LOADER_RESPONSE: {
			return {
				...state,
				hydrated: true,
				status: action.payload?.status,
				errorCode: action.payload?.errorCode,
				errorDescription: action.payload?.errorDescription,
				gameLoaderResponse: action.payload?.result?.gameLoaderResponse
			};
		}
		case SET_GAME_LOADER_REQUEST_PENDING: {
			return {
				...state,
				gameLoaderRequestPending: action.payload
			};
		}
		case SET_LOAD_AS: {
			return {
				...state,
				loadAs: action.payload
			};
		}
		case SET_GAME_MODE: {
			return {
				...state,
				gameMode: action.payload
			};
		}
		default:
			return state;
	}
};

export const registerReducer = () => reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
